import { StateCreator } from "zustand";

import { getDevice } from "../../helpers/detectDevice";
import { Device, GeolocationData, LoginData } from "../../types/common";
import { PlayerStoreProperties } from "../store";
import { StoreMiddlewares } from "../storeTypes";

export type UserDataSliceState = {
  device: Device;
  geolocation: GeolocationData;
  isContinuingWatching: boolean;
  loginData: LoginData;
};

type UserDataSliceActions = {
  setGeolocation: (geolocation: GeolocationData) => void;
  setLoginData: (loginData: LoginData) => void;
};

export type UserDataSlice = UserDataSliceState & UserDataSliceActions;

export const USER_DATA_SLICE_DEFAULTS: UserDataSliceState = {
  device: getDevice(),
  geolocation: {
    countryCode: "FI",
    isPortabilityRegion: true
  },
  isContinuingWatching: false,
  loginData: {
    loggedIn: false,
    residenceInFinland: false,
    userId: undefined
  }
};

export const userDataSlice: StateCreator<
  PlayerStoreProperties,
  StoreMiddlewares,
  [],
  UserDataSlice
> = set => ({
  ...USER_DATA_SLICE_DEFAULTS,
  setGeolocation: geolocation => set({ geolocation }, false, "setGeolocation"),
  setLoginData: loginData => set({ loginData }, false, "setLoginData")
});
